module.exports = __webpack_public_path__ + "static/media/local-listing-banner.db1e58a7.jpg";